













import { CredentialResponse } from '@/store/modules/transactions'
import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class UtxoCredentials extends Vue {
    @Prop() credentials!: CredentialResponse
}
